import { getTracingHeaders,PortalApiClient } from '../portalApiClient';

import { getMessageFromResponse } from './errorHelper';
import { LoginModeResponse } from './types';

export async function getLoginMode(
  email: string | null,
  client: PortalApiClient
): Promise<LoginModeResponse> {
  try {
    const response = await client.http.request({
      path: '/auth/login-mode',
      method: 'POST',
      headers: getTracingHeaders(),
      ...(email && { body: { email } }),
    });
    if (!response?.ok) {
      const message = await getMessageFromResponse(response);
      throw new Error(message ?? 'Failed requesting user login mode.');
    }
    const res = await response?.json();
    return LoginModeResponse.parse(res);
  } catch (e: unknown) {
    console.error(e);
    throw e;
  }
}
